/**
 * Exports are requested with responseType 'blob'. When the firm requires
 * approval (OL-154), the server answers 202 with JSON instead of a file, and
 * that JSON arrives as a Blob too. Callers check here before saving the file.
 */

const readText = (blob) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => resolve('');
    reader.readAsText(blob);
  });

/**
 * The server's message when the export was sent for approval, otherwise null
 * (the blob is the file).
 */
export const pendingApprovalMessage = async (blob) => {
  if (!blob || !String(blob.type || '').includes('application/json')) return null;

  try {
    const body = JSON.parse(await readText(blob));
    return body?.data?.pending_approval ? body.message || 'Your export was sent for approval.' : null;
  } catch {
    return null;
  }
};

/**
 * The server's message from a refused export, e.g. "Please select at least
 * one contact to export." The JSON error arrives as a Blob too.
 */
export const exportErrorMessage = async (error) => {
  if (error instanceof Blob) {
    try {
      return JSON.parse(await readText(error))?.message || null;
    } catch {
      return null;
    }
  }

  return error?.message || null;
};
